import React, { Children } from 'react'
import * as ReactDOM from 'react-dom'
import { Spin } from 'antd'
import './index.less'

export default {
	open<P>(component?: React.ReactElement<P>): Promise<any> {
		return new Promise(resolve => {
			let div = document.createElement('div')
			div.className = 'app-full-mask-layer'
			document.body.appendChild(div)
			document.body.style.overflow = 'hidden'

			let content = component || <Spin />

			ReactDOM.render(content, div)
		})
	},

	close() {
		document.onclick = null;
		if(document.querySelector('.app-full-mask-layer')){
		  document.body.removeChild(document.querySelector('.app-full-mask-layer'))
		}
	},
}



// WEBPACK FOOTER //
// ./src/qcc/AppFullMaskLayer/index.tsx